import { render } from "./VTransition.vue?vue&type=template&id=063b2a6a&scoped=true"
import script from "./VTransition.vue?vue&type=script&lang=js"
export * from "./VTransition.vue?vue&type=script&lang=js"

import "./VTransition.vue?vue&type=style&index=0&id=063b2a6a&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-063b2a6a"

export default script